/**
 * BILLFISH GEAR - MASTER SYNC (V295 - STABILITY FIX)
 */

const BF_COLOR_MAP = {
    "Blue": ["Blue", "Navy", "Midnight Blue", "Carolina Blue", "Columbia Blue", "Steel Blue", "Polo Blue", "Dark Blue", "Steel Blue/black"],
    "Grey": ["Grey", "Light Grey", "Dark Grey", "Heather Grey", "Grey/Black"],
    "White": ["White", "Arctic", "White/Grey"],
    "Dark Camo": ["Dark Camo", "Steel Camo"],
    "Grey Camo": ["Grey Camo", "Snow Camo"],
    "Black": ["Black"]
};

const FID = { COLOR: '553091', SIZE: '553092', STYLE: '560365' };

let isProcessing = false;
let urlSyncTimer = null;
let lastStateHash = "";
let removalLock = new Set();

const normalize = v => decodeURIComponent((v || "").replace(/\+/g, ' ')).toLowerCase().trim().replace(/\s*\(\d+\)\s*$/g, '').trim();

const getParent = v => {
    const txt = normalize(v);
    for (const p in BF_COLOR_MAP) {
        if (normalize(p) === txt || BF_COLOR_MAP[p].map(normalize).includes(txt)) return p;
    }
    return null;
};

const triggerClick = el => {
    if (!el) return;
    ['mousedown', 'mouseup', 'click'].forEach(evt => 
        el.dispatchEvent(new MouseEvent(evt, { bubbles: true, cancelable: true, view: window }))
    );
};

/* --- 1. UI ENFORCEMENT --- */
const style = document.createElement('style');
style.innerHTML = `
    .globo-selected-items .selected-item, .globo-selected-items .gf-filter-item, 
    .globo-selected-items a, .spf-filter-selected a, .globo-selected-items .gf-option-label { 
        display: none !important; visibility: hidden !important; opacity: 0 !important; 
        pointer-events: none !important; position: absolute !important; z-index: -1 !important;
    }
    .gf-option-box .gf-clear, .gf-block .gf-clear, .gf-block-title .gf-clear { display: none !important; }
    .gf-option-${FID.COLOR} .gf-scroll:not(.custom-built) { display: none !important; }
    .bf-pill {
       display: inline-flex !important; align-items: center; cursor: pointer; background: #e4e4e4 !important;
       border-radius: 2.6rem; padding: .5rem 1rem; font-family: 'Montserrat'; text-transform: uppercase;
       font-size: 14px; color: #000000 !important; transition: background 0.1s ease; line-height: 1.5; font-weight: 500;
       margin-right: 8px; margin-bottom: 0px;
    }
        @media only screen and (max-width: 767px) {.bf-pill{ margin-right: 0px; padding: .4rem .8rem;     font-size: 12px;}}
    .bf-pill .gf-close { margin-left: 10px; font-weight: bold; font-size: 16px; line-height: 1; pointer-events: none; }
    .bf-swatch-btn { display: flex; align-items: center; width: 100%; background: none; border: none; padding: 7px 0; cursor: pointer; text-align: left; font-family: 'Montserrat', sans-serif; }
    .bf-swatch-btn[aria-checked="true"] .gf-label { font-weight: 700; color: #000; }
    .bf-pill .gf-close svg{color: #000; width: 12px; height: 12px; }
     @media only screen and (min-width: 768px) {.theme-store-id-801.spf-layout-theme.gf-left #gf-tree {max-width: 250px;}}
`;
document.head.appendChild(style);

/**
 * SIDEBAR BUILDER: Generates the custom color swatch UI
 * ---------------------------------------------------
 * This function hides the native Globo scroll area and injects a custom
 * list of Parent Colors (e.g., Blue, Grey) mapped from BF_COLOR_MAP.
 */
function buildSidebar() {
    const originalBlock = document.querySelector(`.gf-option-${FID.COLOR} .gf-block-content`);
    
    // Prevent re-building if the sidebar doesn't exist or is already built
    if (!originalBlock || document.querySelector('.custom-built')) return;

    // Create a wrapper for the custom scroll area
    const wrapper = document.createElement('div');
    wrapper.className = 'gf-scroll gf-block-no-scroll custom-built';
    
    const ul = document.createElement('ul');
    ul.className = 'gf-option-box';

    // Iterate through the Parent Colors defined in the map
    Object.keys(BF_COLOR_MAP).forEach(pName => {
        const variants = [pName, ...BF_COLOR_MAP[pName]];
        
        // Find the first available native button to clone the swatch image/color
        const repBtn = variants
            .map(v => document.querySelector(`.gf-option-${FID.COLOR} button[data-fvalue="${v}" i]`))
            .find(Boolean);

        if (repBtn) {
            const li = document.createElement('li');
            const btn = document.createElement('button');
            
            // --- SPECIFIC CHANGE: STRICT ACTIVE CHECK ---
            // Ensure we don't show active if the parent is currently in the removalLock
            const isActuallyInLock = removalLock.has(pName);
            
            // Scan ALL variants in this group. If ANY are aria-checked="true", the parent is active.
            const isAnyVariantActive = variants.some(v => {
                const nativeBtn = document.querySelector(`.gf-option-${FID.COLOR} button[data-fvalue="${v}" i]`);
                return nativeBtn && nativeBtn.getAttribute('aria-checked') === 'true';
            });

            const isActive = !isActuallyInLock && isAnyVariantActive;

            btn.className = 'bf-swatch-btn';
            btn.setAttribute('aria-checked', isActive);
            btn.dataset.parent = pName;

            // Clone the visual swatch (Image or Color Circle) from the native app
            const swatch = repBtn.querySelector('.gf-swatch-image, .gf-option-one-color, .gf-option-two-color');
            if (swatch) btn.appendChild(swatch.cloneNode(true));

            // Add the Parent Label (e.g., "BLUE")
            const label = document.createElement('span');
            label.className = 'gf-label';
            label.innerText = pName;
            btn.appendChild(label);

            // Handle Selection Logic
            btn.onclick = (e) => { 
                e.preventDefault(); 
                handleColorSelect(pName, btn); 
            };

            li.appendChild(btn);
            ul.appendChild(li);
        }
    });

    wrapper.appendChild(ul);
    originalBlock.appendChild(wrapper);
}
/**
 * FILTER INTERACTION HANDLER: Manages Parent Color Selection
 * ---------------------------------------------------
 * When a custom parent swatch is clicked, this function:
 * 1. Identifies all child variants (e.g., Blue -> Navy, Arctic).
 * 2. Programmatically triggers clicks on native Globo buttons.
 * 3. Syncs the UI and URL after a stability delay.
 */
async function handleColorSelect(pName, btn) {
    // Prevent duplicate processing or re-selecting an already active filter
    if (isProcessing || btn.getAttribute('aria-checked') === 'true') return;

    isProcessing = true;
    btn.setAttribute('aria-checked', 'true');
    
    // Ensure this parent is removed from the removal lock queue
    removalLock.delete(pName);
    
    // Map the parent and its sub-variants to a normalized list
    const variants = [pName, ...BF_COLOR_MAP[pName]].map(normalize);
    const nativeBtns = document.querySelectorAll(`.gf-option-${FID.COLOR} button[data-fvalue]`);
    
    // Sequentially trigger clicks on all matching native buttons
    for (const nb of nativeBtns) {
        const val = normalize(nb.getAttribute('data-fvalue') || nb.getAttribute('title'));
        
        if (variants.includes(val) && nb.getAttribute('aria-checked') !== 'true') {
            triggerClick(nb);
            
            // Wait 100ms between clicks to allow Globo app to process URL changes
            await new Promise(r => setTimeout(r, 100)); 
        }
    }

    // Final settlement delay to ensure AJAX calls finish before refreshing UI
    setTimeout(() => { 
        isProcessing = false; 
        runUnifiedSync(); 
    }, 1200);
}
/**
 * UNIFIED REMOVAL LOGIC: Handles Pill Deletion & Filter Reset
 * ---------------------------------------------------
 * This function is triggered when a user clicks the 'X' on a filter pill.
 * It manages:
 * 1. Targeted removal of parameters from the URL.
 * 2. Deselecting corresponding native buttons in the sidebar.
 * 3. Triggering a smart re-fetch of products to ensure the grid is updated.
 */
async function performUnifiedReset(item, pillEl) {
    if (isProcessing) return;
    isProcessing = true;
    
    // UI Feedback: Pill ko instantly hide karein taaki user ko responsive lage
    pillEl.style.opacity = "0.2";
    pillEl.style.pointerEvents = "none";
    
    const url = new URL(window.location.href);
    const params = new URLSearchParams(url.search);
    let urlChanged = false;

    if (item.type === 'COLOR') {
        removalLock.add(item.value);
        const variantsToRemove = [item.value, ...BF_COLOR_MAP[item.value]].map(normalize);
        
        // 1. URL Cleanup: Specific color variants ko instantly delete karein
        params.forEach((val, key) => {
            if (key.includes('color') || key.startsWith('gf_')) {
                const currentVals = val.split(/[+,]/).filter(Boolean);
                const filtered = currentVals.filter(v => !variantsToRemove.includes(normalize(v)));
                
                if (filtered.length !== currentVals.length) {
                    if (filtered.length > 0) params.set(key, filtered.join('+'));
                    else params.delete(key);
                    urlChanged = true;
                }
            }
        });

        // 2. Sidebar Sync: Native buttons ko uncheck karein
        const activeBtns = document.querySelectorAll(`.gf-option-${FID.COLOR} button[aria-checked="true"]`);
        for (const nb of activeBtns) {
            if (variantsToRemove.includes(normalize(nb.getAttribute('data-fvalue') || nb.getAttribute('title')))) {
                triggerClick(nb);
                await new Promise(r => setTimeout(r, 60)); 
            }
        }
    } else {
        // 3. Size/Style URL Cleanup
        params.forEach((val, key) => {
            if (key.includes('size') || key.includes('style') || key.startsWith('gf_')) {
                const rawVals = val.split(/[+,]/).filter(Boolean);
                const filtered = rawVals.filter(v => normalize(v) !== normalize(item.label));
                
                if (filtered.length !== rawVals.length) {
                    if (filtered.length > 0) params.set(key, filtered.join('+'));
                    else params.delete(key);
                    urlChanged = true;
                }
            }
        });

        // 4. Sidebar Sync: Specific Size/Style button uncheck karein
        const targetBtn = Array.from(document.querySelectorAll('.gf-option-block button[aria-checked="true"]'))
            .find(btn => normalize(btn.querySelector('.gf-label')?.innerText || btn.getAttribute('title')).includes(normalize(item.label)));
        
        if (targetBtn) {
            triggerClick(targetBtn);
            await new Promise(r => setTimeout(r, 100));
        }
    }

    // 🔥 RELOAD ENGINE: 
    if (urlChanged) {
        // Update URL instantly without page refresh
        window.history.replaceState({ bfSync: true }, '', url.toString());
        
        // Signal Globo to refresh the grid with REMAINING filters
        if (window.GloboFilter && typeof window.GloboFilter.filter === 'function') {
            window.GloboFilter.filter(); 
            console.log("Filter removed. Syncing remaining products...");
        }
    }

    // Cleanup: Pill 
    setTimeout(() => { 
        isProcessing = false; 
        pillEl.remove();
        runUnifiedSync(); 
    }, 1100);
}
/**
 * MAIN SYNC ENGINE: Coordinates Sidebar, Pills, and URL State
 */
function runUnifiedSync() {
    // Exit if a selection or removal process is currently active
    if (isProcessing) return;

    // Ensure the custom color group is rendered in the sidebar
    buildSidebar();
    
    const container = document.querySelector('.globo-selected-items');
    if (!container) return;

    let itemsMap = new Map();
    const pageTitle = (document.querySelector('.collection-tabs .active-tab, h1.collection-title')?.innerText || "").trim().toUpperCase();

    /* --- PHASE 1: PILL DETECTION & GENERATION --- */

    // Scan all active native buttons to identify current filter state
    document.querySelectorAll('.gf-option-block button[aria-checked="true"]').forEach(btn => {
        const isColorBlock = btn.closest(`.gf-option-${FID.COLOR}`);
        const labelText = (btn.querySelector('.gf-label')?.innerText || btn.getAttribute('title') || "").trim();
        
        if (isColorBlock) {
            const p = getParent(btn.getAttribute('data-fvalue') || labelText);
            if (p && !removalLock.has(p)) {
                itemsMap.set("COL_" + p.toUpperCase(), { type: 'COLOR', label: p.toUpperCase(), value: p });
            }
        } else {
            // Clean the label (e.g., "Hooded Long Sleeve")
            const clean = labelText.replace(/size[:\s-]*|style[:\s-]*|pf_t_[:\s-]*/gi, '').replace(/\s*\(\d+\)\s*$/g, '').trim().toUpperCase();
            
            // 🔥 3. REDUNDANCY CHECK:
            if (clean && !/clear/i.test(clean) && clean !== pageTitle) {
                itemsMap.set("OTH_" + clean, { type: 'OTHER', label: clean, value: labelText });
            }
        }
    });

    // Hash current state to prevent redundant DOM updates
    const finalItems = Array.from(itemsMap.values());
    const hash = finalItems.map(i => i.label).sort().join('|');
    
    if (hash === lastStateHash && container.querySelectorAll('.bf-pill').length === finalItems.length) return;
    lastStateHash = hash;

    // Clear old pills and render the new set
    container.querySelectorAll('.bf-pill').forEach(t => t.remove());
    finalItems.forEach(item => {
        const pill = document.createElement('div');
        pill.className = 'bf-pill';
        pill.innerHTML = `<span>${item.label}</span><span class="gf-close"><svg viewBox="0 0 20 20"><path d="M11.414 10l6.293-6.293a1 1 0 10-1.414-1.414L10 8.586 3.707 2.293a1 1 0 00-1.414 1.414L8.586 10l-6.293 6.293a1 1 0 101.414 1.414L10 11.414l6.293 6.293A.998.998 0 0018 17a.999.999 0 00-.293-.707L11.414 10z" fill="currentColor"></path></svg></span>`;
        
        pill.onclick = (e) => { 
            e.preventDefault(); 
            performUnifiedReset(item, pill); 
        };
        container.prepend(pill);
    });

    /* --- PHASE 2: AGGRESSIVE URL CLEANUP --- */

    if (urlSyncTimer) clearTimeout(urlSyncTimer);
    
    // Delayed execution to allow the Globo App to settle its native URL updates
    urlSyncTimer = setTimeout(() => {
        const url = new URL(window.location.href);
        const params = new URLSearchParams(url.search);
        let changed = false;

        // Check if any filters are still active in the URL
        const hasActiveFilters = Array.from(params.keys()).some(k => 
            k.startsWith('gf_') || k.includes('color') || k.includes('size') || k.includes('style')
        );

        // GLOBAL RESET: If no filters exist, force-refresh the entire product grid
        if (!hasActiveFilters && !isProcessing) {
            if (window.GloboFilter && typeof window.GloboFilter.filter === 'function') {
                window.GloboFilter.filter();
                console.log("All Filters Cleared: Reloading All Products...");
            }
            return;
        }

        // CONSOLIDATION: Replace variant-heavy keys with clean 'Parent' keys
        const colorKeys = Array.from(params.keys()).filter(k => k.startsWith('gf_') || k.includes('color'));
        
        colorKeys.forEach(key => {
            const allVals = params.getAll(key).join('+').split(/[+,]/).filter(Boolean);
            const consolidated = [...new Set(allVals.map(v => getParent(v) || v))].filter(v => !removalLock.has(v));
            const newVal = consolidated.join('+');

            // Replace multiple variant values with a single Parent string
            if (params.getAll(key).join('+') !== newVal) {
                params.delete(key); 
                if (newVal) params.set(key, newVal);
                changed = true;
            }
        });

        // Update browser history without refreshing the page
        if (changed) {
            window.history.replaceState({ bfSync: true }, '', url.origin + url.pathname + '?' + params.toString());
        }
    }, 300); 
    renderPillsFromMap(itemsMap, container);
}

/**
 * INITIALIZATION & EVENT OBSERVERS
 * ---------------------------------------------------
 * These listeners ensure the custom UI stays synced with the Globo Filter app:
 * 1. MutationObserver: Detects DOM changes when products or filters update.
 * 2. Event Listener: Syncs state after the Globo app completes its AJAX request.
 * 3. Polling Interval: Safety net to catch updates missed by observers.
 */

// 1. MUTATION OBSERVER: Monitors the document for any filter or product grid changes
const bfObserver = new MutationObserver(() => { 
    // Only sync if a manual selection/removal is NOT currently in progress
    if (!isProcessing) {
        runUnifiedSync(); 
    }
});

// Start observing the body for child list and subtree changes
bfObserver.observe(document.body, { 
    childList: true, 
    subtree: true 
});

// 2. GLOBO EVENT LISTENER: Fired by the app when an AJAX filtering request finishes
document.addEventListener('gf_complete', () => {
    // Reset the processing flag and clear any temporary removal locks
    isProcessing = false;
    removalLock.clear(); 
    
    // Perform a full UI and URL synchronization
    runUnifiedSync();
});

// 3. IMMEDIATE EXECUTION: Run the sync engine once on initial page load
runUnifiedSync();

// 4. POLLING SAFETY: Runs every 2 seconds to ensure UI consistency if observers miss an update
setInterval(() => { 
    if (!isProcessing) {
        runUnifiedSync(); 
    }
}, 2000);






